export function addQueryParams(baseUrl: string, params?: Record<string, string | null | undefined> | null) {
  if (!params || Object.keys(params).length === 0) {
    return baseUrl;
  }

  const filteredEntries = Object.entries(params).filter(([, value]) => value != null);

  const stringEntries = filteredEntries.map(([key, value]) => [key, String(value)] as [string, string]);

  const searchParams = new URLSearchParams(stringEntries);
  return `${baseUrl}?${searchParams.toString()}`;
}
